<template>
  <v-container grid-list-md>
    <v-layout row justify-center>
      <v-flex xs12 md8>
        <v-form v-model="valid" ref="form">
          <v-card>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    prepend-inner-icon="mdi-format-title"
                    v-model="mensagem.nome"
                    label="Título do Grupo"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="mensagem.idTurmas"
                    :disabled="turmas.length < 1 || mensagem.id != null"
                    :items="turmas"
                    label="Turmas Participantes"
                    :rules="rules"
                    :item-text="
                      turma =>
                        `${turma.serie.nome} - ${turma.nome} - ${turma.serie.nivel.nome}`
                    "
                    multiple
                    chips
                    item-value="id"
                    hint="Seleciona a(s) Turma(s) Participante(s)"
                    persistent-hint
                    required
                  >
                    <template v-slot:prepend-item>
                      <v-list-item ripple @click="AllTurma">
                        <v-list-item-action>
                          <v-icon
                            :color="turmas.length > 0 ? 'indigo darken-4' : ''"
                            >{{ icon }}</v-icon
                          >
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title
                            >Selecionar Todas</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn elevation="0" color="primary" dark @click="submit"
                >Salvar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
    <!-- snakbar -->
    <v-snackbar
      v-model="snack.hide"
      top
      right
      :color="snack.color"
      :timeout="snack.imeout"
      multi-line
    >
      <v-alert :value="true" color="white" :icon="snack.icon" outline>
        {{ this.snack.mensage }}
      </v-alert>
    </v-snackbar>
  </v-container>
</template>

<script>
import { Turma, Mensagem } from '../../service'

export default {
  data() {
    return {
      valid: false,
      rules: [v => !!v || 'Campo requerido.'],
      mensagem: {
        nome: '',
        idTurmas: []
      },
      escola: localStorage.getItem('escola')
        ? localStorage.getItem('escola')
        : '',
      turmas: [],
      snack: {}
    }
  },
  async created() {
    this.turmas = await Turma.findAll({ escola: this.escola })
    if (this.$route.params.id) {
      const mensagem = await Mensagem.findById(this.$route.params.id, {
        escola: this.escola
      })
      this.mensagem = mensagem
      this.mensagem.idTurmas = mensagem.turma.map(turma => turma.id)
    }
  },
  methods: {
    async submit() {
      if (await this.$refs.form.validate()) {
        const novo_grupo = await Mensagem.save(this.mensagem, {
          escola: this.escola
        })
        this.$router.push(`/mensagens/${novo_grupo.id}`)
      }
    },
    AllTurma() {
      this.$nextTick(() => {
        if (this.todasTurmas) {
          this.mensagem.idTurmas = []
        } else {
          this.mensagem.idTurmas = this.turmas.map(t => t.id) //(this.turmas) (turma) => `${turma.serie.nome} - ${turma.nome} - ${turma.serie.nivel.nome}`
        }
      })
    }
  },
  computed: {
    todasTurmas() {
      return this.mensagem.idTurmas.length === this.turmas.length
    },
    turmasSelecionadas() {
      return this.mensagem.idTurmas.length > 0 && !this.todasTurmas
    },
    icon() {
      if (this.todasTurmas) return 'mdi-close-box'
      if (this.turmasSelecionadas) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  }
}
</script>

<style></style>
